import { motion } from "framer-motion";
import { useTranslation } from "@/i18n";

const reveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
};

export default function Manifesto() {
  const { t } = useTranslation();

  const chapters = [
    { number: "01", title: t("manifesto.c1t"), content: t("manifesto.c1x") },
    { number: "02", title: t("manifesto.c2t"), content: t("manifesto.c2x") },
    { number: "03", title: t("manifesto.c3t"), content: t("manifesto.c3x") },
  ];

  return (
    <section id="manifeste" className="relative py-24 sm:py-32 lg:py-40 bg-ink" data-testid="manifesto-section">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-20">
        <motion.div {...reveal} className="flex items-end justify-between gap-8 flex-wrap">
          <div>
            <span className="label-accent" data-testid="manifesto-overline">{t("manifesto.overline")}</span>
            <h2 className="mt-6 font-serif font-light tracking-tight text-3xl sm:text-4xl lg:text-5xl max-w-2xl leading-tight">
              {t("manifesto.h2a")}
              <br />
              <em className="italic text-[#A0A5B1]">{t("manifesto.h2b")}</em>
            </h2>
          </div>
          <p className="max-w-sm text-sm text-[#9BA1B0] leading-relaxed">
            {t("manifesto.side")}
          </p>
        </motion.div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-px bg-gold/10">
          {chapters.map((c, i) => (
            <motion.article
              key={c.number}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              className="group bg-ink p-8 sm:p-10 hover:bg-ink-soft transition-colors duration-500"
              data-testid={`manifesto-chapter-${c.number}`}
            >
              <span className="font-mono text-5xl text-gold/25 group-hover:text-gold/70 transition-colors duration-500 font-light">
                {c.number}
              </span>
              <h3 className="mt-8 font-serif text-xl sm:text-2xl text-[#FAF8F5] leading-snug">
                {c.title}
              </h3>
              <div className="mt-4 w-10 gold-hairline" />
              <p className="mt-6 text-sm text-[#A0A5B1] leading-relaxed">{c.content}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
